export { RoomsCarousel } from './RoomsCarousel.component';
export type { RoomsCarouselProps } from './RoomsCarousel.props';
